import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IPrescriptionLabelModel extends IModel {
  prescriptionLabelId: number;
  name: string;
  instructions: string;
}

export class PrescriptionLabelModel
  extends Model
  implements ModelRecord<IPrescriptionLabelModel>
{
  prescriptionLabelId: number;
  name: string;
  instructions: string;

  constructor(params?: Partial<IPrescriptionLabelModel>) {
    super(params);
    this.prescriptionLabelId = defaultTo(params?.prescriptionLabelId, 0);
    this.name = defaultTo(params?.name, '');
    this.instructions = defaultTo(params?.instructions, '');
  }
}
